import { render, staticRenderFns } from "./ConceptTagSelector.vue?vue&type=template&id=38d83827&scoped=true"
import script from "./ConceptTagSelector.vue?vue&type=script&lang=js"
export * from "./ConceptTagSelector.vue?vue&type=script&lang=js"
import style0 from "./ConceptTagSelector.vue?vue&type=style&index=0&id=38d83827&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d83827",
  null
  
)

export default component.exports